import { useEffect, useState } from "react";

/** Counts down seconds remaining until `Date.now() + totalMs` while `isActive`; resets when inactive. */
export function useCallableWaitCountdown(isActive: boolean, totalMs: number): number {
    const [sec, setSec] = useState(() => Math.ceil(totalMs / 1000));
    useEffect(() => {
        if (!isActive) {
            setSec(Math.ceil(totalMs / 1000));
            return;
        }
        const end = Date.now() + totalMs;
        const tick = () => setSec(Math.max(0, Math.ceil((end - Date.now()) / 1000)));
        tick();
        const id = setInterval(tick, 500);
        return () => clearInterval(id);
    }, [isActive, totalMs]);
    return sec;
}
